import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b994b86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-1 mb-4 ps-5 pe-5 justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"bf-content\" data-v-3b994b86><div class=\"bf-eyebrow\" data-v-3b994b86><img src=\"/media/hc/bf-hc-logo-white.png\" class=\"bf-logo\" alt=\"Hacking Club\" data-v-3b994b86><span data-v-3b994b86>Black Friday 2026</span></div><h2 class=\"bf-title\" data-v-3b994b86>Black Friday começa em <span class=\"bf-highlight\" data-v-3b994b86>01/11</span></h2><p class=\"bf-subtitle\" data-v-3b994b86>Cadastre-se e receba as infos antes.</p></div><span class=\"bf-button\" data-v-3b994b86>Acesse aqui →</span>", 2)
const _hoisted_4 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const LP_URL = "https://blackfriday.hackingclub.com/";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "bf-banner",
      href: LP_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "Black Friday 2026: cadastre-se e receba as infos antes"
    }, _hoisted_4)
  ]))
}
}

})